import { useMemo } from 'react';

import { defaultStyle, getStyleFromName } from '../utils/style';

export const useNameStyle = (name?: string) => {
	return useMemo(() => {
		return name ? getStyleFromName(name) : defaultStyle;
	}, [name]);
};
